import BackendClient from '../../backend-client';
import Problem, { modelFactory } from './model';

export default class ProblemClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  /* async create(element, type, data) {
    try {
      const response = await this.request('post', 'create')({
        element,
        type,
        data,
      }, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      });

      return this.format(response);
    } catch (ex) {
      throw this.handleError(ex);
    }
  } */

  list = async (start, size, filters = {}, sortparam, asc) => {
    const sort = `${sortparam} ${asc === true ? 'asc' : 'desc'}`;
    const response = await this.request('get', 'list')({
      filters,
      start,
      size,
      sort,
    });

    return this.format(response);
  }
}

export {
  Problem,
};
